import Vue from "vue";
import { set as _set } from "lodash";

export const SET = function(state, payload) {
  if (Array.isArray(payload) && payload.length === 2) {
    _set(state, payload[0], payload[1]); // https://lodash.com/docs/4.17.15#set
  } else if (typeof payload !== "object" || payload === null) {
    return throwSetError(payload);
  }

  for (let [key, value] of Object.entries(payload)) {
    Vue.set(state, key, value);
  }
};

function throwSetError(payload) {
  console.error(
    "Payload (of mutation SET) must be either array ([key, value]) or object with key value pairs.",
    payload
  );
}
